// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Chvs","title":"Images90_title__1MrRv","images":"Images90_images__6OQQ_"};